import { Component, OnInit } from '@angular/core';
import { AbstractControl, FormBuilder, FormGroup, Validators } from '@angular/forms';
import * as _ from 'lodash';
import { MatSnackBar } from '@angular/material';
import { Router } from "@angular/router";
import { FuseConfigService } from '../../../../../core/services/config.service';
import { fuseAnimations } from '../../../../../core/animations';
import { FuseNavigationService } from '../../../../../core/components/navigation/navigation.service';
import { ProNavigationModel } from '../../../../../navigation/proNavigation.model';

/**Local file */
import { resetPwd, spekwo, toastMsg } from '../../utils/index';

/**Service file */
import { AuthService } from '../auth.service';
import { UserQueryService } from '../../gql-query-mutation/index';

/** Local component */
import { ToastComponent } from '../../../../../core/components/toast/toast.component';

@Component({
    selector: 'resetPassword',
    templateUrl: './resetPassword.component.html',
    styleUrls: ['./resetPassword.component.scss'],
    animations: fuseAnimations
})
export class ResetPasswordComponent implements OnInit {

    resetPasswordForm: FormGroup;
    resetPasswordFormErrors: any;

    resetPwdValues = resetPwd;
    spekwoValues = spekwo;
    toastMsg = toastMsg;

    allEmails: Array<any> = [];

    isResults: boolean = false;

    constructor(
        private fuseConfig: FuseConfigService,
        private fuseNavigationService: FuseNavigationService,
        private formBuilder: FormBuilder,
        private router: Router,
        public snackBar: MatSnackBar,

        /**Query file */
        public userQueryService: UserQueryService,

        /**Service file */
        public authService: AuthService,
        private _toastComponent: ToastComponent,
    ) {
        this.fuseConfig.setSettings({
            layout: {
                navigation: 'none',
                toolbar: 'none',
                footer: 'none'
            }
        });

        this.resetPasswordFormErrors = {
            email: {},
            password: {},
            passwordConfirm: {}
        };

        this.getAllUserEmail();
    }

    ngOnInit() {
        //Form controls
        this.initializeForm();

    }

    /**Get all users email */
    getAllUserEmail() {

        this.authService.getAllUserEmail()
            .then((res: any) => {

                this.allEmails = res;
                this.initializeForm();
            })
    }

    //Form controls
    initializeForm() {
        this.resetPasswordForm = this.formBuilder.group({
            email: ['', [Validators.required, Validators.email, isEmailExist(this.allEmails)]],
            password: ['', Validators.required],
            passwordConfirm: ['', [Validators.required, confirmPassword]]
        });

        this.resetPasswordForm.valueChanges.subscribe(() => {
            this.onResetPasswordFormValuesChanged();
        });
    }

    onResetPasswordFormValuesChanged() {

        for (const field in this.resetPasswordFormErrors) {

            if (!this.resetPasswordFormErrors.hasOwnProperty(field)) {
                continue;
            }

            // Clear previous errors
            this.resetPasswordFormErrors[field] = {};

            // Get the control
            const control = this.resetPasswordForm.get(field);

            if (control && control.dirty && !control.valid) {
                this.resetPasswordFormErrors[field] = control.errors;
            }
        }
    }

    emailChange() {
        this.resetPasswordForm.get('email').setValue(this.resetPasswordForm.value.email.trim());
    }

    /**Password reset functionality */
    doResetPwd() {

        this.isResults = true;
        this.resetPasswordForm.value.email = this.resetPasswordForm.value.email.toLowerCase();
        // Get userId of user
        this.userQueryService.GET_USER(this.resetPasswordForm.value.email)
            .valueChanges
            .subscribe((response: any) => {

                if (response &&
                    response.data.allUsers &&
                    response.data.allUsers.edges.length > 0) {

                    var result = response.data.allUsers.edges[0].node;

                    // 2.Save details
                    this.userQueryService.UPDATE_SPECIFI_FIELD_BY_USERID("password",
                        this.resetPasswordForm.value.password, result.userId)
                        .subscribe(response => {

                            this.showToast(this.toastMsg.resetSuccess);

                            window.localStorage.setItem("userUID", result.userId);
                            window.localStorage.setItem("role", this.spekwoValues.Pro);

                            // Set the navigation model
                            this.fuseNavigationService.setNavigationModel(new ProNavigationModel());

                            setTimeout(() => {
                                this.router.navigate(['apps/home']);
                            }, 10);


                        }, (err) => {
                            this.showToast(this.toastMsg.resetFailed);
                        })
                } else {
                    this.showToast(this.toastMsg.resetFailed);
                }

            })

    }

    /** Toast message*/

    showToast(message) {

        this.isResults = false;
        this._toastComponent.showToast(message);

    }
}

function confirmPassword(control: AbstractControl) {
    if (!control.parent || !control) {
        return;
    }

    const password = control.parent.get('password');
    const passwordConfirm = control.parent.get('passwordConfirm');

    if (!password || !passwordConfirm) {
        return;
    }

    if (passwordConfirm.value === '') {
        return;
    }

    if (password.value !== passwordConfirm.value) {
        return {
            passwordsNotMatch: true
        };
    }
}

// Check email is already exist
function isEmailExist(mails: any) {

    return (control: AbstractControl): { [key: string]: boolean } | null => {

        if (!control.parent || !control) {
            return;
        }

        var matched = _.find(mails, function (o) {
            return o.email.toLowerCase() === control.value.toLowerCase()
        });

        if (matched == undefined) {
            return { emailExist: false };
        }
        return null;
    };

}


// WEBPACK FOOTER //
// E:/NeoSME/1.Full Project Spekwo/pro/prodash/src/app/main/content/apps/authentication/resetPassword/resetPassword.component.ts